export const initialState = {
  visible: false,
  modal_name: "",
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "MODAL_VIEW":
      return {
        ...state,
        visible: action.payload.flag,
        modal_name: action.payload.modal_name,
      };
    default:
      return state;
  }
};
